import React, { useEffect, useState } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import Modal from '../../modals/Modal';

const DatePickerModal = ({
  open,
  onClose,
  onSubmit,
  title = 'Filter by Date',
  fromLabel = 'From Date',
  toLabel = 'To Date',
  initialFromDate = null,
  initialToDate = null,
}) => {
  const [fromDate, setFromDate] = useState(initialFromDate ? moment(initialFromDate) : moment().subtract(28, 'days'));
  const [toDate, setToDate] = useState(initialToDate ? moment(initialToDate) : moment().add(28, 'days'));

  useEffect(() => {
    if (open) {
      setFromDate(initialFromDate ? moment(initialFromDate) : moment().subtract(28, 'days'));
      setToDate(initialToDate ? moment(initialToDate) : moment().add(28, 'days'));
    }
  }, [open, initialFromDate, initialToDate]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      submitButton="Submit"
      onSubmit={() => onSubmit(fromDate, toDate)}
    >
      <div className="d-flex direction-column space-between">
        <div style={{ padding: '32px 16px' }}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <Grid container spacing={3}>
              <Grid size={{ xs: 12, md: 6 }}>
                <div className="secondary">{fromLabel}</div>
                <DatePicker
                  format="DD/MM/YYYY"
                  value={fromDate}
                  onChange={(date) => setFromDate(date)}
                  maxDate={toDate || undefined}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      variant: 'standard',
                    },
                  }}
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <div className="secondary">{toLabel}</div>
                <DatePicker
                  format="DD/MM/YYYY"
                  value={toDate}
                  onChange={(date) => setToDate(date)}
                  minDate={fromDate || undefined}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      variant: 'standard',
                    },
                  }}
                />
              </Grid>
            </Grid>
          </LocalizationProvider>
        </div>
      </div>
    </Modal>
  );
};

DatePickerModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  title: PropTypes.string,
  fromLabel: PropTypes.string,
  toLabel: PropTypes.string,
  initialFromDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.number]),
  initialToDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.number]),
};

export default DatePickerModal;
